import { useOutletContext } from "react-router-dom";
import { Wallet } from "lucide-react";
import ClosingsTab from "../components/finance/ClosingsTab";

/**
 * Página dedicada de Caja y Cierres.
 *
 * Reutiliza el componente ClosingsTab que ya implementa todos los flujos
 * (abrir caja, cerrar caja, cierre de ventas, cierre de inventario,
 * cierre de producción, timeline mensual). Se ofrece como entry-point
 * propio en el sidebar bajo el grupo "Ventas y caja".
 */
export default function CashPage() {
  const { currentRestaurant } = useOutletContext();

  return (
    <div className="space-y-6" data-testid="cash-page">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-700 flex items-center justify-center flex-shrink-0">
          <Wallet className="w-5 h-5" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Caja y Cierres</h1>
          <p className="text-sm text-muted-foreground">
            Abre la caja, registra el cierre de ventas, inventario y producción.
            El timeline mensual te da una visión rápida de qué días quedaron pendientes.
          </p>
        </div>
      </div>

      {currentRestaurant?.restaurant_id && (
        <ClosingsTab restaurantId={currentRestaurant.restaurant_id} />
      )}
    </div>
  );
}
